module.exports = __webpack_public_path__ + "static/media/mrh-icon.a2b57520.svg";